import get from 'lodash/get';
import useTranslation from 'next-translate/useTranslation';
import { COURSE_DOMAIN, DEFAULT_DOMAIN, PRISMIC_API_IDS } from 'prismic/config';
import { Data } from 'prismic/types';
import { isDomainCourse } from 'helpers/host';
import Column from 'components/layout/Grid/Column';
import { ComposedLinkStyled, ContainerStyled, SpanSourseStyled } from './LinkSourceDomain.styles';

interface LinkSourceDomainProps {
  pageData: Data;
}

export const LinkSourceDomain: React.FC<LinkSourceDomainProps> = ({ pageData }) => {
  const { t } = useTranslation('common');

  const canonical = get(pageData, PRISMIC_API_IDS.metaCanonical, null);
  const isCourseDomain = canonical ? isDomainCourse(canonical) : false;

  return (
    <ContainerStyled>
      <Column start={{ xs: 1, lg: 3 }} span={{ xs: 12, lg: 8 }}>
        <SpanSourseStyled>{t('source')}:&nbsp;</SpanSourseStyled>
        <ComposedLinkStyled href={canonical}>
          {isCourseDomain ? COURSE_DOMAIN : DEFAULT_DOMAIN}
        </ComposedLinkStyled>
      </Column>
    </ContainerStyled>
  );
};
